import e from"react";const a=({children:a,className:c=""})=>e.createElement("li",{className:c},a);export{a as ListItem};
//# sourceMappingURL=ListItem.js.map
